<template>
   <Forms ref="frmPermission"
            :title="title"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
          >
          <div>
            <div id="form-seacch">
              <label class="labelseach">Imobiliária</label>
               <autocomplete-z ref="ImobliariaVendasTypeahead"
                          placeholder="Digite uma imobiliária"
                          iconClass="fas fa-sign"
                          :serializer="(imobiliaria) => imobiliaria.nome"
                          :debounceLength="3"
                          :formField="formsearch.imobiliaria"
                          v-on:search="onSearchImobliariaVendas"
                          v-on:changeCode="onChangeCodoImobliariaVendas"
                          :ShowCode="false"
                           />
              <label class="labelseach mt-3">Empreendimento</label>
                <select v-model="formsearch.empreendimentoId" name="statusVistoria" class="form-control" id="exampleFormControlSelect2">
                    <option :value="''">Todos</option>
                    <option v-for="(data,i) in dataEnteprise" :value="data.id" :key="i">{{data.nome}}</option>
                </select>
              <label class="labelseach mt-3">Período</label>
              <div class="periodos">
                <button id="semanal" v-on:click="filter" class="btn-periodos">SEMANAL</button>
                <button id="mensal"  v-on:click="filter" class="btn-periodos">MENSAL</button>
              </div>
              <div class="periodos footer">
                <button id="anual"  v-on:click="filter" class="btn-periodos-active">ANUAL</button>
                <button id="personalizado" v-on:click="filter"  class="btn-periodos">PERSONALIZADO</button>
              </div>
              <div class="d-flex align-items-end" v-if="showDate">
                <b-form-datepicker
                  placeholder="__/__/____"
                  v-model="formsearch.DtInicial"
                  locale="pt-BR"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
                <label class="labelseach ml-1 mr-1" > à </label>
                  <b-form-datepicker
                  placeholder="__/__/____"
                  v-model="formsearch.DtFinal"
                  locale="pt-BR"
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
                </div>
            </div>
          </div>
    </Forms>
</template>

<script>
import Searchsalesbyaccredited from './searchsalesbyaccredited'
export default Searchsalesbyaccredited

</script>

<style scoped>
#form-seacch{
  display: flex;
  flex-direction: column;
  align-content: center;
}
.labelseach{
  font-weight: 700;
  color: #666;
  font-size: 14px;
  margin-bottom: 5px;
  padding-bottom: 0;
  font-family: Segoe UI;
}

.footer{
  margin-bottom: 10%;
}
.btn-footer, .footer {
  background-color: transparent !important;
}
.periodos{
 display: flex;
 flex-wrap: wrap;
 justify-content: space-around;

}
.btn-periodos{
  background-color: #EBEBEB;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 150px;
  font-weight: bold;
  color: grey;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}
.btn-periodos-active{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 150px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesbyaccredited/components/searchsalesbyaccredited/searchsalesbyaccredited.vue